<template>
  <div class="animated fadeIn" id="list-decomptes">
    <transition name="fade">
      <b-card no-body>
        <div slot="header">
          <i class="fa fa-justify mr-2"></i>
          <strong>Gestion des Délégations Commerciales</strong>
        </div>
        <b-card-body class="small-padding">
          <b-row class="">
            <b-col md="4">
              <b-list-group>
                <b-list-group-item :class="{'bg-warning': delegationId === delegation.id}" v-for="(delegation, index) in allDelegations" :index="index" :key="index" :item="delegation" :active="delegationId === delegation.id">{{ delegation.nom }} <i v-if="canManageDelegation()" class="icon fa fa-trash float-right clickable ml-2 text-danger" @click="deleteDelegation(delegation.id)"></i><i v-if="canManageDelegation()" class="icon fa fa-pencil float-right clickable" @click="edit(delegation)"></i></b-list-group-item>
              </b-list-group>
            </b-col>
            <b-col md="8">
              <b-card :header-bg-variant="action === 'create' ? 'primary' : 'warning' ">
                <template v-slot:header >
                   <i class="fa fa-justify mr-2"></i>
                  <strong>{{ libelleFormCardTitle }}</strong>
                </template>
                <b-row>
                  <b-col md="6">
                    <b-form-group
                      label='Nom'
                      label-for='nom'
                    >
                      <b-form-input id='nom' type='text' v-model="nom" :class="{hasError: errors.nom !== ''}"></b-form-input>
                      <span class='field-error'>{{ errors.nom }}</span>
                    </b-form-group>
                    <b-form-group
                      label='Adresse'
                      label-for='adresse'
                    >
                      <b-form-input id='adresse' type='text' v-model="adresse" :class="{hasError: errors.adresse !== ''}"></b-form-input>
                      <span class='field-error'>{{ errors.adresse }}</span>
                    </b-form-group>
                     <b-form-group
                      label='Adresse 2'
                      label-for='adresse2'
                    >
                      <b-form-input id='adresse2' type='text' v-model="adresse2"></b-form-input>
                    </b-form-group>
                    <b-form-group
                      label='Code Postal'
                      label-for='cp'
                    >
                      <b-form-input id='cp' type='text' v-model="cp" :class="{hasError: errors.cp !== ''}"></b-form-input>
                      <span class='field-error'>{{ errors.cp }}</span>
                    </b-form-group>
                    <b-form-group
                      label='Ville'
                      label-for='ville'
                    >
                      <b-form-input id='ville' type='text' v-model="ville" :class="{hasError: errors.ville !== ''}"></b-form-input>
                      <span class='field-error'>{{ errors.ville }}</span>
                    </b-form-group>
                    <b-form-group
                      label='Bureau postal'
                      label-for='bureau'
                    >
                      <b-form-input id='bureau' type='text' v-model="bureau"></b-form-input>
                    </b-form-group>
                    <b-form-group
                      label='Email'
                      label-for='email'
                    >
                      <b-form-input id='email' type='text' v-model="email" :class="{hasError: errors.email !== ''}"></b-form-input>
                      <span class='field-error'>{{ errors.email }}</span>
                    </b-form-group>
                    <b-form-group
                      label='Téléphone'
                      label-for='telephone'
                    >
                      <b-form-input id='telephone' type='text' v-model="telephone" :class="{hasError: errors.telephone !== ''}" :formatter="telFormat" lazy-formatter></b-form-input>
                      <span class='field-error'>{{ errors.telephone }}</span>
                    </b-form-group>
                    <b-form-group
                      label='Nom du contact'
                      label-for='nomContact'
                    >
                      <b-form-input id='nomContact' type='text' v-model="nomContact" :class="{hasError: errors.nomContact !== ''}"></b-form-input>
                      <span class='field-error'>{{ errors.nomContact }}</span>
                    </b-form-group>
                    <b-form-group
                      label='Assistant·e Commercial'
                      label-for='ac'
                    >
                      <b-form-input id='ac' type='text' v-model="ac"></b-form-input>
                    </b-form-group>
                    <b-form-group label='Code postal à rattacher' label-for='cpToAttach' v-if="attachCp">
                      <b-row class="mb-1">
                        <b-col sm="7">
                          <b-form-input id='cpToAttach' type='text' v-model="cpToAttach" :class="{hasError: errors.cpToAttach !== ''}"></b-form-input>
                        </b-col>
                        <b-col sm="5">
                          <b-button size="md" variant="success" @click.prevent="makeAttachment()"><i class="fa fa-save"></i> Attacher</b-button>
                        </b-col>
                      </b-row>
                      <span class='field-error'>{{ errors.cpToAttach }}</span>
                    </b-form-group>
                    <b-row>
                      <b-col md="12">
                        <b-button v-if="delegationId" size="md" variant="success" @click="attachCp = !attachCp" class="pull-right mr-2 mt-1"><i class="fa fa-plus"></i> Attacher un CP</b-button>
                        <b-button v-if="action === 'create'" size="md" variant="primary" @click="create()" class="pull-right mr-2 mt-1"><i class="fa fa-save"></i> Créer</b-button>
                        <b-button v-if="action === 'modify'" size="md" variant="warning" @click="modify()" class="pull-right mr-2 mt-1"><i class="fa fa-save"></i> Modifier</b-button>
                        <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="pull-right mr-2 mt-1">
                          <i class="fa fa-eraser"></i> Annuler
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col md="6">
                    <h6>Liste des codes postaux rattachés <span v-if="delegationId">( {{ attachedCps.length }} )</span></h6>
                    <b-badge v-for="cp in attachedCps" :key="cp.id" pill variant="light">{{cp.code_postal}}</b-badge>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </transition>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth'
import { hasRule, rules } from "@/utils/rulesHelper"
import { SlickList } from 'vue-slicksort'
import itemList from '@/components/SortListItem'

export default {
  components: {
    SlickList,
    itemList
  },
  data() {
    return {
      attachCp: false,
      attachedCps: [],
      delegationId: '',
      allDelegations: [],
      cpToAttach: '',
      nom: '',
      adresse: '',
      adresse2: '',
      cp: '',
      ville: '',
      bureau: '',
      email: '',
      telephone: '',
      nomContact: '',
      ac: '',
      action: 'create',
      libelleFormCardTitle: 'Création d\'une délégation commerciale',
      errors: {
        nom: '',
        adresse: '',
        cp: '',
        ville: '',
        email: '',
        telephone: '',
        nomContact: '',
        cpToAttach: '',
      }
    }
  },
  mounted() {
    this.getDelegations()
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json';
    this.$axios.defaults.headers.common['Provider'] = getProvider();
  },
  methods: {
    getDelegations() {
      let self = this

      this.$store.commit("IS_LOADING", true)
      this.$axios
        .get("/delegation/all")
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          this.allDelegations = response.data.data
          // console.log(this.allDelegations)
        })
        .catch(function(error) {
          // console.log(error)
          self.$store.commit("IS_LOADING", false)
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    create() {
      if (this.validate()) {
        let self = this;
        let telephone = this.telephone
        telephone = telephone.toString()
        telephone = telephone.replace(/ /g, '')
        let dataPost = {
          'nom': this.nom,
          'adresse': this.adresse,
          'adresse2': this.adresse2,
          'cp': this.cp,
          'bureau_postal': this.bureau,
          'ville': this.ville,
          'email': this.email,
          'telephone': telephone,
          'nom_contact': this.nomContact,
          'ac': this.ac,
        }
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/delegation/add', dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            this.$swal({
              position: 'top', type: 'success', title: 'Succès', text: 'Création effectuée avec succés.', showConfirmButton: false, timer: 5000
            })
            this.clearForm()
            this.clearError()
            this.getDelegations()
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue lors de la création de la délégation, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    modify() {
      if (this.validate()) {
        let self = this;
        let telephone = this.telephone
        telephone = telephone.toString()
        telephone = telephone.replace(/ /g, '')
        let dataPost = {
          'nom': this.nom,
          'adresse': this.adresse,
          'adresse2': this.adresse2,
          'cp': this.cp,
          'bureau_postal': this.bureau,
          'ville': this.ville,
          'email': this.email,
          'telephone': telephone,
          'nom_contact': this.nomContact,
          'ac': this.ac,
        }
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/delegation/modify/'+this.delegationId, dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            this.clearForm()
            this.clearError()
            this.getDelegations()
            this.$swal({
              position: 'top', type: 'success', title: 'Succès', text: 'Modifications effectuées avec succés.', showConfirmButton: false, timer: 5000
            })
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue lors de la modification de la délégation, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    deleteDelegation(delegationId) {
      let self = this;
      this.$swal
        .fire({
          title: "Êtes-vous sûr?",
          text: "Voulez-vous vraiment supprimer cette délégation ?",
          type: "warning",
          reverseButtons: true,
          showCancelButton: true,
          allowOutsideClick: false,
          cancelButtonColor: "#ff1744",
          confirmButtonText: "Annuler",
          cancelButtonText: "Supprimer"
        })
        .then(result => {
          if (!result.value) {
            this.$store.commit("IS_LOADING", true)
            this.$axios
              .get("/delegation/delete/"+delegationId).then(response => {
                this.$store.commit("IS_LOADING", false)
                this.getDelegations()
                this.$swal({
                  position: 'top', type: 'success', title: 'Succès', text: 'Suppression effectuée avec succés.', showConfirmButton: false, timer: 5000
                })
              })
              .catch(function(error) {
                  self.$store.commit("IS_LOADING", false)
                  console.log(error.response.status)
                  let errorText = "Une erreur est survenue, lors de la suppression de la délégation. Si le problème persiste, merci de faire un ticket au support DOSI."
                  if (error.response.status === 403) { errorText = "Vous n'êtes pas autorisé à effectuer cette action" }
                  self.$swal({
                  position: "top",
                  type:"error",
                  title:"Attention !!",
                  text:errorText,
                  showConfirmButton: false,
                  timer: 5000
                })
              })
          }
        })
    },
    makeAttachment() {
      if (this.validateAttachCp()) {
        this.clearError()
        let self = this;
        this.$swal
          .fire({
            title: "Êtes-vous sûr?",
            text: "Voulez-vous vraiment rattacher ce code postal à cette délégation et le détacher de celle à laquelle il était précédement attaché ?",
            type: "warning",
            reverseButtons: true,
            showCancelButton: true,
            allowOutsideClick: false,
            cancelButtonColor: "#ff1744",
            confirmButtonText: "Annuler",
            cancelButtonText: "Attacher"
          })
          .then(result => {
            if (!result.value) {
              let dataPost = {
                'cp': this.cpToAttach,
                'delegation_id': this.delegationId,
              }
              this.$store.commit("IS_LOADING", true)
              this.$axios
                .post("/delegation/attach", dataPost).then(response => {
                  this.$store.commit("IS_LOADING", false)
                  this.getDelegations()
                  this.edit(response.data.delegation)
                  this.$swal({
                    position: 'top', type: 'success', title: 'Succès', text: 'Rattachement effectuée avec succés.', showConfirmButton: false, timer: 5000
                  })
                })
                .catch(function(error) {
                    self.$store.commit("IS_LOADING", false)
                    console.log(error.response.status)
                    let errorText = "Une erreur est survenue, lors du rattachement du CP à la délégation. Si le problème persiste, merci de faire un ticket au support DOSI."
                    if (error.response.status === 403) { errorText = "Vous n'êtes pas autorisé à effectuer cette action" }
                    self.$swal({
                    position: "top",
                    type:"error",
                    title:"Attention !!",
                    text:errorText,
                    showConfirmButton: false,
                    timer: 5000
                  })
                })
            }
          })
      }
    },
    canManageDelegation() {
      return hasRule(rules.MANAGE_TABLE_DELEGATION)
    },
    edit(delegation) {
      this.delegationId = delegation.id
      this.nom = delegation.nom
      this.adresse = delegation.adresse
      this.adresse2 = delegation.adresse2
      this.cp = delegation.cp
      this.bureau = delegation.bureau_postal
      this.ville = delegation.ville
      this.email = delegation.email
      this.telephone = this.telFormat(delegation.telephone)
      this.nomContact = delegation.nom_contact
      this.ac = delegation.ac
      this.attachedCps = delegation.codes_postaux
      this.cpToAttach = ''
      this.action = 'modify'
      this.libelleFormCardTitle = 'Modification de la délégation commerciale : ' + delegation.nom
    },
    validate() {
      let regEmail = this.$store.getters.getRegMail
      let valid = true

      if (this.nom.trim() === '') {
        this.errors.nom = 'Le nom est obligatoire'
        valid = false;
      }

      if (this.adresse.trim() === '') {
        this.errors.adresse = 'L\'adrese est obligatoire'
        valid = false;
      }

      if (this.cp.trim() === '') {
        this.errors.cp = 'Le cp est obligatoire'
        valid = false;
      }

      if (this.ville.trim() === '') {
        this.errors.ville = 'La ville est obligatoire'
        valid = false;
      }

      if (this.email.trim() === '') {
        this.errors.email = 'L\'email est obligatoire'
        valid = false;
      } else if (!regEmail.test(this.email.trim())) {
          valid = false
          this.errors.email = 'Veuillez entrer une adresse mail valide'
        }

      if (this.telephone.trim() === '') {
        this.errors.telephone = 'Le numéro de téléphone est obligatoire'
        valid = false;
      }
      if (this.telephone && this.telephone.trim() !== '') {
        let telephone = this.telephone.trim()
        telephone = telephone.toString()
        telephone = telephone.replace(/ /g, '')

        if (telephone.length !== 10) {
          valid = false
          this.errors.telephone = 'Le numéro de téléphone doit contenir 10 chiffres'
        // } else if (!telephone.test(/^\d+$/)) {
        } else if (!/^\d+$/.test(telephone)) {
          valid = false
          this.errors.telephone = 'Le numéro de téléphone ne doit contenir que des chiffres'
        }
      }

      if (this.nomContact.trim() === '') {
        this.errors.nomContact = 'Le nom du contact est obligatoire'
        valid = false;
      }

      return valid
    },
    validateAttachCp() {
      let valid = true
      let cpToAttach = this.cpToAttach.trim()
      cpToAttach = cpToAttach.toString()
      if (this.cpToAttach.trim() === '') {
        this.errors.cpToAttach = 'Le code postal à rattaché est obligatoire'
        valid = false;
      } else {
        if (!/^\d+$/.test(cpToAttach)) {
          this.errors.cpToAttach = 'Le code postal ne doit contenir que des chiffres'
          valid = false;
        }
        if (cpToAttach.length !== 5) {
          valid = false
          this.errors.cpToAttach = 'Le code postal doit contenir 5 chiffres'
        }
      }

      return valid
    },
    clearForm() {
      this.clearError()
      this.delegationId = ''
      this.action = 'create'
      this.nom = ''
      this.adresse = ''
      this.adresse2 = ''
      this.cp = ''
      this.bureau = ''
      this.ville = ''
      this.email = ''
      this.telephone = ''
      this.nomContact = ''
      this.ac = ''
      this.attachedCps = []
      this.cpToAttach = ''
      this.attachCp = false
      this.libelleFormCardTitle = 'Création d\'une délégation commerciale'
    },
    clearError() {
      this.errors.nom = ''
      this.errors.adresse = ''
      this.errors.cp = ''
      this.errors.ville = ''
      this.errors.email = ''
      this.errors.telephone = ''
      this.errors.nomContact = ''
      this.errors.cpToAttach = ''
    },
    telFormat (value) {
      if (!value || value === '') return ''
      value = value.toString()
      value = value.replace(/ /g, '')
      value = value.replace(/\./g, '')
      value = value.replace(/-/g, '')

      let telFormated = ''
      for (var i = 0; i < value.length; i++) {
        if (i % 2 === 0 && i !== 0) {
          telFormated = telFormated + ' ' + value[i]
        } else {
          telFormated = telFormated + value[i]
        }
      }
      return telFormated
    },
  },
  // filters: {
  //   telFormat (value) {
  //     if (!value || value === '-') return '-'
  //     value = value.toString()
  //     value = value.replace(/ /g, '')
  //     value = value.replace(/\./g, '')
  //     value = value.replace(/-/g, '')

  //     let telFormated = ''
  //     for (var i = 0; i < value.length; i++) {
  //       if (i % 2 === 0 && i !== 0) {
  //         telFormated = telFormated + ' ' + value[i]
  //       } else {
  //         telFormated = telFormated + value[i]
  //       }
  //     }
  //     return telFormated
  //   },
  // },
}
</script>